export default "__VITE_ASSET__6f1dcf10__"